<template>
    <div>
        <p v-loading="loading" id="totalScore">Nota: {{ score }}</p>
    </div>
</template>

<script>
import { getInscriptionByCourse } from '@/requests/inscriptions'
import allCoursesVue from './myCourses/allCourses.vue';
export default {
    props: [ 'courseId' ],
    data() {
        return {
            loading: false,
            score: '--'
        }
    },
    mounted() {
        this.loading = true
        getInscriptionByCourse({ userId: this.$session.get('userId'), courseId: this.courseId })
        .then((response)=>{
            let ins = response.items[0]
            if(ins){
                if(ins.isApproved){
                    var allScore = 0
                    var count = 0
                    for (let i = 0; i < ins.results.length; i++) {
                        if(ins.results[i].score){
                            allScore = allScore + ins.results[i].score
                            count++
                        }
                        
                    }
                    this.score = Math.round(allScore/count)
                    this.loading = false
                }
                
            }
            this.loading = false
        })
    }

}
</script>

<style>
    #totalScore {
        color: #0056A8;
        margin: 5px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/courses/courseScore.vue